import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/components/destination_page/overview/Card.css';

const Card = React.forwardRef(
  ({ title, children, loading, isOpen, onToggle }, ref) => {
    const innerRef = useRef(null);
    const [height, setHeight] = useState('0px');

    useEffect(() => {
      if (innerRef.current) {
        setHeight(isOpen
          ? `${innerRef.current.scrollHeight}px`
          : '0px'
        );
      }
    }, [isOpen, children]);

    return (
      <div
        className={`overview-card${isOpen ? ' open' : ''}`}
        ref={ref}
      >
        <button
          className="overview-card-summary"
          onClick={onToggle}
          aria-expanded={isOpen}
        >
          <h3>{title}</h3>
          <span className="arrow" />
        </button>
        <div
          className="overview-card-body"
          style={{ height }}
        >
          <div
            className="overview-card-body-inner"
            ref={innerRef}
          >
            {loading ? <div className="card-skeleton" /> : children}
          </div>
        </div>
      </div>
    );
  }
);

Card.propTypes = {
  title:    PropTypes.string.isRequired,
  children: PropTypes.node,
  loading:  PropTypes.bool,
  isOpen:   PropTypes.bool,
  onToggle: PropTypes.func,
};

Card.defaultProps = {
  loading:  false,
  isOpen:   false,
  onToggle: () => {},
};

export default Card;
